import { useState } from "react"
import { formatDate } from "../../Announcements/dates"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"
import { Link } from "@inertiajs/react"

interface MediaAttachmentCardProps {
  attachment: any;
  href?: string;
  width?: number | string;
  height?: number | string;
}

export function MediaAttachmentCard({ attachment, href, width, height }: MediaAttachmentCardProps) {
  const [isHovered, setIsHovered] = useState(false)

  const containerStyle: React.CSSProperties = {
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    cursor: 'pointer',
    transform: isHovered ? 'translateY(-0.5px)' : 'translateY(0)',
    borderColor: isHovered ? 'var(--color-primary)' : 'var(--color-base-300)',
    display: 'block',
  }

  const content = (
    <>
      <div
        key={attachment.id}
        style={{
          ...(width || height
            ? { width: width ?? '100%', height: height ?? 'auto' }
            : { aspectRatio: '1 / 1' }
          ),
          backgroundColor: 'var(--color-base-100)',
          backgroundImage: `url(${attachment.public_url})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
        }}
        title={attachment.title || undefined}
      >
        {attachment.description && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.3), var(--color-neutral))',
              opacity: isHovered ? 1 : 0,
              transition: 'opacity 0.3s ease',
              display: 'flex',
              alignItems: 'flex-end',
              padding: '16px',
              pointerEvents: 'none',
            }}
          >
            <p
              style={{
                color: 'var(--color-white)',
                margin: 0,
                fontSize: '14px',
                lineHeight: '1.4',
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 4,
                WebkitBoxOrient: 'vertical',
              }}
            >
              {formatDate(attachment.created_at)}
              {' - '}
              {attachment.description}
            </p>
          </div>
        )}
      </div>
      <div style={{
        backgroundColor: isHovered ? 'var(--color-neutral)' : 'var(--color-primary)',
        padding: '4px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        color: 'var(--color-base-100)',
        transition: 'background-color 0.3s ease',
      }}>
        <div style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          minWidth: 0,
        }}>
          {attachment.title || attachment.filename}
        </div>
        {href && (
          <div style={{
            flexShrink: 0,
            marginLeft: '4px',
          }}>
            <FontAwesomeIcon icon={faArrowRight} />
          </div>
        )}
      </div>
    </>
  )

  if (href) {
    return (
      <Link
        href={href}
        style={containerStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {content}
      </Link>
    )
  }

  return (
    <div
      style={containerStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {content}
    </div>
  )
}
